import { Controller } from "@hotwired/stimulus"

// Submits the form when an input fires its action — replaces inline
// onchange="this.form.requestSubmit()", which CSP blocks.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
